module.exports = __webpack_public_path__ + "img/ml.bb0f1681.png";